export const SRG_LINK = 'https://srg-it.ru/9r/insurance/applications';
